/**
 * Created by agonzalez on 07/01/19.
 */

angular
	.module('servicepro.workorderresulteditor', [
		'ngResource',
		'ng-sortable',
		'ui.bootstrap'
	]);